import {_Album} from "./_Album";

export const _Admin = {
    Album:_Album
}